import * as React from 'react';
/**
 *
 * Original name: email lock
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6785
 *
 */
export const EmailLockPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 14v30a6.007 6.007 0 0 0 6 6h23.98l.012-4H14a2 2 0 0 1-2-2V20.828l20 20 20-20v10.21a8.254 8.254 0 0 1 4 1.49V14H8Zm41.172 4L32 35.171 14.828 18h34.344Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.5 39.3v3.667H42l-.033 11.855c0 1.755 1.552 3.178 3.466 3.178H54.5c1.915 0 3.467-1.423 3.467-3.178L58 42.967h-2.5V39.3a4.3 4.3 0 0 0-4.3-4.3h-2.4a4.3 4.3 0 0 0-4.3 4.3Zm4.767-.967a1.3 1.3 0 0 0-1.3 1.3L48 42.967h4l-.033-3.334a1.3 1.3 0 0 0-1.3-1.3h-1.4ZM50 53c1.657 0 3-1.313 3-2.933 0-1.62-1.343-2.934-3-2.934s-3 1.314-3 2.934S48.343 53 50 53Z", fill: "currentColor" })));
